import { useQuery } from '@tanstack/react-query';

import { getPatient } from '../../../api/patients';
import { useAuth } from '../../auth/AuthProvider';

export function usePatient(id: string) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['patient', id],
    queryFn: () => getPatient(id, tokens!.access_token),
    enabled: Boolean(id && tokens?.access_token),
  });
}
